import { TransportType } from '../../../common/enums/TransportType'
import { Notification } from './Notification'
import { SendingStatus } from '../enums/SendingStatus'
import { EventType } from '../enums/EventType'

export interface NotificationDTO {
  id?: string
  title: string
  message: string
  recipientID: string
  senderID: string
  deliveryStatus: SendingStatus
  createdAt: Date
  eventType: EventType
  transportType: TransportType
}

export function fromModel(n: Notification): NotificationDTO {
  return {
    id: n.id,
    title: n.title,
    message: n.message,
    recipientID: n.recipientID,
    senderID: n.senderID,
    deliveryStatus: n.deliveryStatus,
    createdAt: n.createdAt,
    eventType: n.eventType,
    transportType: n.transportType,
  }
}

export function toModel(d: NotificationDTO): Notification {
  return new Notification({
    id: d.id,
    title: d.title,
    message: d.message,
    recipientID: d.recipientID,
    senderID: d.senderID,
    deliveryStatus: d.deliveryStatus,
    createdAt: new Date(d.createdAt),
    eventType: d.eventType,
    transportType: d.transportType,
  })
}
